const getKeywords = (query: string): string[] => {
  return query
    .split(' ')
    .filter((v) => v !== '')
    .map((v) => v.toLowerCase());
};
export { getKeywords };
